import src from "IMAGE";
export default { src, width: 280, height: 217, blurWidth: 0, blurHeight: 0};
